var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Contact.Messages.Submit, Vendd.Contact, function (envelope) {
        var options = {
            url: 'CommonService.svc/ContactSubmit',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Contact, new Vendd.Contact.Messages.SubmitSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Contact, new Vendd.Contact.Messages.SubmitFailure(response));
        }

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});